import React, { useState, useEffect, useRef } from "react";
import EmploymentHistoryForm from "./EmploymentHistoryForm.js";
import Navbar from "./Navbar.js";
import ReusableProgessBar from "components/common/ReusableProgessBar";
import DirectionLine from "./DirectionLine.js";
import { useDispatch, useSelector } from "react-redux";
import { goBack } from "../../../../../src/redux/slice/onboardingFormSlice.js";
import { fetchgetInvitedUserDetailsById } from "../../../../../src/redux/slice/getInvitedUserDetailsSlice";
import { submitAllFormData } from "../../../../../src/redux/formApiActions";
import { toast, ToastContainer } from "react-toastify";
import { fetchgetPreOnboardingDocsById } from "../../../../../src/redux/slice/getPreOnboardingDocsByIdSlice";
import { useForm } from "react-hook-form";

export default function ProfessionalRefForm() {
  const dispatch = useDispatch();
  const {
    register,
     formState: { errors },
    handleSubmit,
    setValue,
    watch
  } = useForm();
  const InviteData = useSelector(
    (state) => state.persistedReducer.forms.inviteData,
  );
  const paramId = InviteData?.id;
  const { getInvitedUserDetailsById } = useSelector(
    (state) => state.getInvitedUserDetailsById,
  );
  const docs = useSelector((state) => state.getPreOnboardingDocsById.docs);

  const { employmentHistory } = getInvitedUserDetailsById ?? {};
  const savedData = employmentHistory;

  const [showEmpHistory, setEmpHistory] = useState([]);
  const [year, setYear] = useState(savedData?.length ?? 0);
  const empHistoryDatePickerRef = useRef([]);
  const [empHistoryDateRanges, setempHistoryDateRanges] = useState([
    [null, null],
    [null, null],
    [null, null],
    [null, null],
    [null, null],
  ]);
  const [docError, setDocError] = useState({});

  useEffect(() => {
    dispatch(fetchgetInvitedUserDetailsById(paramId));
  }, []);

  useEffect(() => {
    setValue("yrOfExp", year); // update form state
    const count = Math.min(5, Math.max(0, year));
    setEmpHistory(Array.from({ length: count }, () => ({})));
  }, [year, setValue]);

  useEffect(() => {
    // Initialize or resize refs
    empHistoryDatePickerRef.current = Array.from(
      { length: year },
      (_, i) => empHistoryDatePickerRef.current[i] || React.createRef(),
    );
    // Initialize or resize date ranges
    setempHistoryDateRanges((prev) => {
      const updated = [...prev];
      while (updated.length < year) updated.push([null, null]);
      return updated.slice(0, year);
    });
  }, [year]);

  useEffect(() => {
    setValue("yrOfExp", employmentHistory?.length ?? 0);
  }, [employmentHistory, setValue]);

  useEffect(() => {
    employmentHistory.map(async (education, index) => {
      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `expCertFile.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `relievingLetterFile.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `offerLetter.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `lastThreeMonthSalarySlip1.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `lastThreeMonthSalarySlip2.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `lastThreeMonthSalarySlip3.${index}`,
          id: paramId,
        }),
      );

      dispatch(
        fetchgetPreOnboardingDocsById({
          type: `lastThreeMonthBankStatement.${index}`,
          id: paramId,
        }),
      );
    });
  }, []);

  const restructureFormData = (data) => {
    const historyArray = [];
    const PrevEmpName = data.PrevEmpName || [];

    for (let i = 0; i < year; i++) {
      const entry = {
        previousEmployerName: data.PrevEmpName[i],
        employeeCode: data.employeeCode[i],
        mobileNumber: data.telephoneNo[i],
        designation: data.designation[i],
        department: data.department[i],
        reasonForLeaving: data.leaveReason[i],
        managerName: data.managerName[i],
        managerContactNo: data.managerContactNo[i],
        managerEmail: data.managerEmailId[i],
        address: data.PrevEmpAddress[i],
        employmentPeriodFrom: data.empPeriodFrom[i],
        employmentPeriodTo: data.empPeriodTo[i],
        positionType: data.position[i],
      };
      historyArray.push(entry);
    }

    return historyArray;
  };

  const handleFormSubmit = async (data) => {
    const expFileErrors = {};
    let isExpFileMissing = false;

    // List of required keys per index
    const requiredFields = [
      "expCertFile",
      "offerLetter",
      "lastThreeMonthSalarySlip1",
      "lastThreeMonthSalarySlip2",
      "lastThreeMonthSalarySlip3",
      "lastThreeMonthBankStatement",
    ];

    for (let index = 0; index < year; index++) {
      requiredFields.forEach((fieldName) => {
        const dynamicKey = `${fieldName}.${index}`;
        if (!docs[dynamicKey]) {
          expFileErrors[dynamicKey] = true;
          isExpFileMissing = true;
        }
      });
    }

    if (isExpFileMissing) {
      setDocError((prev) => ({
        ...prev,
        ...expFileErrors,
      }));

      toast.error("Please upload all required documents before submitting.", {
        className: "toast-error-custom",
        autoClose: 4000,
      });
      return;
    }
    const restructuredData = restructureFormData(data);
    const finalPayload = {
      employmentHistory: restructuredData,
      type: "FULL_UPDATE",
      status: "PARTIAL_COMPLETED",
    };
    dispatch(submitAllFormData(finalPayload, paramId,"saveandnext"));
  };

  const handleSaveAsDraft = () => {
    try {
      const data = watch();
      const restructuredData = restructureFormData(data);

      const finalPayload = {
        employmentHistory: restructuredData,
        type: "PARTIAL_UPDATE",
        status: "DRAFT",
      };

      dispatch(submitAllFormData(finalPayload, paramId,"draft"));
    } catch (error) {
      toast.error("Failed to save draft. Please try again.", {
        className: "toast-error-custom",
        autoClose: 4000,
      });
    }
  };
  console.log('showEmpHistory',showEmpHistory)

  return (
      <div className="wrapper">
        <Navbar />
        <div className="sidebar">
          <div className="sidebar-wrapper">
            <ReusableProgessBar />
          </div>
        </div>
        <div className="main-panel">
          <div className="form-content">
            <div className="container-fluid form-navbar">
              <div className="personaldetail-form">
                <DirectionLine />
                <div className="personalDetailForm">
                  {/* table content */}
                  <form
                    onSubmit={handleSubmit(handleFormSubmit)}
                    className="edu-form-container"
                  >
                    <div className="personalDetailHeading">
                      <h6 className="educationalHeadline">
                        EXPERIENCE DETAILS
                      </h6>
                    </div>
                    <div className="attachmentContainer">
                      <div className="attachmentLabel">
                        {" "}
                        <h6 className="attachmentHeadline">
                          Total experienced Companies :
                        </h6>
                      </div>
                      <div className="customCounter">
                        <button
                          type="button"
                          onClick={() =>
                            setYear((prev) => Math.max(0, prev - 1))
                          }
                        >
                          −
                        </button>
                        <span>{year}</span>
                        <button
                          type="button"
                          onClick={() =>
                            setYear((prev) => Math.min(5, prev + 1))
                          }
                        >
                          +
                        </button>
                        <input
                          type="hidden"
                          value={year}
                          {...register("yrOfExp")}
                        />
                      </div>
                    </div>
                    {/* employment history */}
                    {console.log("showEmpHistory", showEmpHistory)}
                    {showEmpHistory?.map((_, index) => (
                      <EmploymentHistoryForm
                        key={index}
                        index={index}
                        errors={errors}
                        setValue={setValue}
                        register={register}
                        empHistoryDateRanges={empHistoryDateRanges}
                        setempHistoryDateRanges={setempHistoryDateRanges}
                        empHistoryDatePickerRef={empHistoryDatePickerRef}
                        setDocError={setDocError}
                        docError={docError}
                      />
                    ))}
                    <div className="educationSaveButtons">
                      <button
                        type="button"
                        className="profBackBtn"
                        onClick={() => dispatch(goBack())}
                      >
                        Back
                      </button>
                      <button
                        type="button"
                        className="saveBtn"
                        onClick={handleSaveAsDraft}
                      >
                        Save As Draft
                      </button>
                      <button type="submit" className="saveNextBtn">
                        Save And Next{" "}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
  );
}
